var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex pa-2",attrs:{"outlined":"","tile":""}},[_c('div',[_vm._v("I'm a flexbox container!")])])}
var staticRenderFns = []

export { render, staticRenderFns }